import { useSelector, useDispatch } from 'react-redux';
import type { RootState, AppDispatch } from '../store';
import { setCredentials, logout as logoutAction } from '../store/slices/authSlice';
import { api } from '../services/api';
import { locationApi } from '../services/locationApi';
import type { User } from '../services/authApi';

export function useAuth() {
  const dispatch = useDispatch<AppDispatch>();
  const { user, token, isAuthenticated } = useSelector((state: RootState) => state.auth);

  const login = (user: User, token: string) => {
    dispatch(setCredentials({ user, token }));
  };

  const logout = () => {
    dispatch(logoutAction());
    dispatch(api.util.resetApiState());
    dispatch(locationApi.util.resetApiState());
  };

  return { user, token, isAuthenticated, login, logout };
}
